import { useState } from "react";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import CloudDownload from "@material-ui/icons/CloudDownload";
import JSZip from 'jszip';
import { getUserContactsLists, exportFeatures } from "./service";
import AlertDialogSlide from "../AlertDialogSlide";

const DownloadData = (_) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [featuresDialogOpen, setFeaturesDialogOpen] = useState(false);

  const downloadContent = async (url) => {
    const res = await fetch(url);
    return await res.blob();
  };

  const downloadFilesAsZip = async (azBlobUrls) => {
    const nowDt = new Date();
    const year = nowDt.getFullYear();
    const month = `${('00' + (nowDt.getMonth() + 1)).slice(-2)}`;
    const date = `${('00' + nowDt.getDate()).slice(-2)}`;
    const folderName = `${year}_${month}${date}_ユーザーメアドリスト`;
    const contents = await Promise.all(azBlobUrls.map(
      async (blobUrl) => {
        return {
          fileName: blobUrl.split('?')[0].split('/').slice(-1)[0], // NOTE: Get file name from Blob url with SAS.
          blobData: await downloadContent(blobUrl),
        };
      }
    ));
    const zipBlob = await generateZipBlob(contents, folderName);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(zipBlob);
    a.download = `${folderName}.zip`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const generateZipBlob = async (contents, folderName) => {
    const zip = new JSZip();
    const folder = zip.folder(folderName);
    contents.forEach(content => {
      folder.file(content.fileName, content.blobData);
    });
    return await zip.generateAsync({ type: 'blob' });
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleFeaturesDialogOpen = () => {
    setFeaturesDialogOpen(true);
  };

  const handleFeaturesDialogClose = () => {
    setFeaturesDialogOpen(false);
  };

  const proceedDownload = async () => {
    handleDialogClose();
    const azBlobUrls = await getUserContactsLists();
    await downloadFilesAsZip(Object.values(azBlobUrls));
  };

  const proceedFeaturesDownload = async () => {
    handleFeaturesDialogClose();
    const res = await exportFeatures();
    if (!res) return;
    const contentDisposition = res.headers['content-disposition'] || '';
    const match = contentDisposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : 'feature-flags.xlsx';
    const blob = new Blob([res.data], {
      type: res.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Grid className="dashboard">
      <Typography variant="h5" className="dashboard-title text-bold">
        ダウンロード対象データ一覧
      </Typography>
      <TableContainer className="dashboard-loguibld-table background-white">
        <Grid>
          <TableContainer>
            <Table size="small" aria-label="table">
              <TableHead className="table-head">
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="white-text text-center">データ名</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-body">
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="text-center">
                    ユーザーメアドリスト
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell className="padding-last-td s-ta-r text-left">
                    <Fab
                      className={"white-text button-logWalk button-feature-flag mr-5"}
                      variant="extended"
                      onClick={e => {
                        handleDialogOpen()
                      }}
                    >
                      <CloudDownload>ダウンロード</CloudDownload>
                    </Fab>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="text-center">
                    フィーチャーフラグリスト
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell className="padding-last-td s-ta-r text-left">
                    <Fab
                      className={"white-text button-logWalk button-feature-flag mr-5"}
                      variant="extended"
                      onClick={e => {
                        handleFeaturesDialogOpen()
                      }}
                    >
                      <CloudDownload>ダウンロード</CloudDownload>
                    </Fab>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </TableContainer>
      <AlertDialogSlide
        cb={proceedDownload}
        contentText="※ ZIP形式でダウンロードされます。解凍後にCSVファイルが取り出されます。"
        handleClose={handleDialogClose}
        negativeBntText="キャンセル"
        open={dialogOpen}
        positiveBntText="ダウンロード"
        title="ユーザーメアドリストをダウンロードしますか？"
      />
      <AlertDialogSlide
        cb={proceedFeaturesDownload}
        contentText="※ Excel形式でダウンロードされます。"
        handleClose={handleFeaturesDialogClose}
        negativeBntText="キャンセル"
        open={featuresDialogOpen}
        positiveBntText="ダウンロード"
        title="フィーチャーフラグリストをダウンロードしますか？"
      />
    </Grid>
  );
}

export default DownloadData;
